import React from 'react';

function AdminMembers() {
    return <>회원 관리</>;
}

export default AdminMembers;
